// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3b7UQ","productName":"Table_productName__3xZWU"};